<template>
	<div>
		<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
		<b-row>
			<b-col></b-col>
			<b-col cols lg="10">
				<b-card bg-variant="light" style="margin-top: 15px;">
					<b-form>
						<h2 class="title">{{$lang.settings.contracts.new}}</h2>
						<hr>

						<b-form-group
							:label="$lang.settings.contracts.name">
							<b-form-input v-model="contracts.name"
								required
								:placeholder="$lang.settings.contracts.name" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.contracts.sequence">
							<b-form-input
								v-model="contracts.sequence"
								required
								:placeholder="$lang.settings.contracts.sequence" />
						</b-form-group>

						<hr>
						<div>
							<b-row>
								<b-col></b-col>
								<b-col cols lg="4">
									<b-button variant="primary" class="title" block value="Save" v-on:click="createContractType"  >{{$lang.buttons.save}}</b-button>
								</b-col>
								<b-col lg="4">
									<b-button variant="danger"  class="title" block value="Cancel" @click="$router.go(-1)">{{$lang.buttons.cancel}}</b-button>
								</b-col>
								<b-col></b-col>
							</b-row>
						</div>
					</b-form>
				</b-card>
			</b-col>
			<b-col></b-col>
		</b-row>
	</div>
</template>

<script>
import { dateFormat } from '../../../utils.js'
import { mapState } from 'vuex'

export default {
	data() {
		return {
			contracts: {
				name: '',
				sequence: '',
			},
			dateFormat: dateFormat,
			breadcrumb: [{'text': this.$lang.settings.settings,'to': '/'},{'text': this.$lang.settings.contracts.title,'to': '/contracts'}, {'text': this.$lang.settings.costCenterNew, 'href': '#'}],
		}
	},
	methods: {
		createContractType() {
			this.$store.dispatch('createContractType', this.contracts)
			this.$router.push('/contracts')
		},
	},
	created() {
		this.$Progress.start()
		if(this.$route.params.contractTypeId) {
			let contractTypeId = this.$route.params.contractTypeId
			this.$store.dispatch('fetchContractType', { contractTypeId }).then( () => {
				this.contracts = this.$store.getters.contractType;
			} )
		}

		this.$Progress.finish()
	},
	computed: {
		...mapState(['currentUser'])
	}
}
</script>
